import { render, staticRenderFns } from "./ReportForkliftTruckSelector.vue?vue&type=template&id=294cf075&scoped=true&"
import script from "./ReportForkliftTruckSelector.vue?vue&type=script&lang=js&"
export * from "./ReportForkliftTruckSelector.vue?vue&type=script&lang=js&"
import style0 from "./ReportForkliftTruckSelector.vue?vue&type=style&index=0&id=294cf075&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294cf075",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItemSection,QItemLabel,QItem,QSeparator,QCardActions,QBtn,QSpace} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItemSection,QItemLabel,QItem,QSeparator,QCardActions,QBtn,QSpace}, component.options.components || {})
